import {
  Button as ButtonBase,
  Typography,
  WithTheme,
  styled,
} from '@material-ui/core'

const BUTTON_HEIGHT = 51
const BUTTON_WIDTH = 240

const IMAGE_HEIGHT = 290
const IMAGE_HEIGHT_MEDIUM = 220

interface ImageProps extends WithTheme {
  size: 'big' | 'medium'
}

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
  padding: theme.spacing(4.3, 3.6),
}))

export const Image = styled('img')(({ theme, size }: ImageProps) => ({
  height: size === 'big' ? IMAGE_HEIGHT : IMAGE_HEIGHT_MEDIUM,
  marginBottom: theme.spacing(2.3),
}))

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: 24,
  lineHeight: '28px',
  fontWeight: 700,
  alignSelf: 'flex-start',
  marginBottom: theme.spacing(5.9),
}))

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: 28,
  lineHeight: '33px',
  fontWeight: 500,
  marginBottom: theme.spacing(1.6),
}))

export const Paragraph = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  lineHeight: '21px',
  fontWeight: 400,
  marginBottom: theme.spacing(3.7),
}))

export const ButtonWrapper = styled('div')({
  display: 'flex',
})

export const Button = styled(ButtonBase)(({ theme }) => ({
  textTransform: 'none',
  fontSize: 18,
  width: BUTTON_WIDTH,
  height: BUTTON_HEIGHT,
  lineHeight: '21px',
  padding: theme.spacing(1.5),
  '&:first-child': {
    '&:not(:last-child)': {
      marginRight: theme.spacing(5.6),
    },
  },
}))
